import {
  GetVideosQuery,
  PagedVideoResponse,
  RenameVideoDto,
  SearchVideosQuery,
  VideoDto,
} from "@repo/api/video";
import { MoveVideoToFolderDto, SearchVideosResponse } from "@repo/api/folder";
import { AmplifilesClient } from "./api-client";

export class VideoApi {
  static async getPagedVideos(teamExternalId: string, query: GetVideosQuery) {
    const response = await AmplifilesClient.instance.get(
      `/team/${teamExternalId}/video`,
      {
        params: query,
      },
    );

    return PagedVideoResponse.parse(response.data);
  }

  static async renameVideo(
    teamExternalId: string,
    videoExternalId: string,
    data: RenameVideoDto,
  ): Promise<VideoDto> {
    const response = await AmplifilesClient.instance.patch(
      `/team/${teamExternalId}/video/${videoExternalId}`,
      data,
    );

    return VideoDto.parse(response.data);
  }

  static async moveVideoToFolder(
    teamExternalId: string,
    videoExternalId: string,
    data: MoveVideoToFolderDto,
  ): Promise<VideoDto> {
    const response = await AmplifilesClient.instance.patch(
      `/team/${teamExternalId}/video/${videoExternalId}/folder`,
      data,
    );

    return VideoDto.parse(response.data);
  }

  static async searchVideos(teamExternalId: string, query: SearchVideosQuery) {
    const response = await AmplifilesClient.instance.get(
      `/team/${teamExternalId}/video/search`,
      {
        params: query,
      },
    );

    return SearchVideosResponse.parse(response.data);
  }
}
